import React from 'react';
import PropTypes from 'prop-types';

class InputQuantity extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      previousQuantity: this.props.quantity,
      quantity: this.props.quantity,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.timer = null;
  }

  handleChange(event) {
    let newQuantity = parseInt(event.target.value);
    if (isNaN(newQuantity)) {
      return;
    }

    if (this.timer) {
      clearTimeout(this.timer);
    }

    this.setState({ quantity: newQuantity });

    this.timer = setTimeout(() => {
      const minimum = this.props.minimum || 1;
      if (newQuantity < minimum) {
        newQuantity = minimum;
      }

      const step = this.props.step || 1;
      if ((newQuantity - minimum) % step !== 0) {
        newQuantity = minimum + Math.ceil((newQuantity - minimum) / step) * step;
      }

      if (this.props.limit && newQuantity > this.props.limit) {
        newQuantity = this.props.limit;
      }

      this.setState({ quantity: newQuantity });

      if (newQuantity !== this.state.previousQuantity) {
        this.props.onChangeQuantity(newQuantity);
        this.setState({ previousQuantity: this.quantity });
      }
    }, 400);
  }
  render() {
    return (
      <input
        className={`input ${this.props.className}`}
        disabled={this.props.disabled}
        max={this.props.limit}
        min={this.props.minimum || 1}
        name={this.props.name}
        step={this.props.step || 1}
        type="number"
        value={this.state.quantity}
        onChange={this.handleChange}
      />
    );
  }
}

InputQuantity.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  limit: PropTypes.number,
  minimum: PropTypes.number,
  quantity: PropTypes.number.isRequired,
  step: PropTypes.number,
  onChangeQuantity: PropTypes.func,
};

export default InputQuantity;
